import { AuthStepTemplate } from '@/app/_auth/steps/_common/auth-step-template'

export const ErrorStep = () => (
  <AuthStepTemplate>
    <AuthStepTemplate.Header>
      <AuthStepTemplate.H1 keyName='auth.steps.error.title' />
    </AuthStepTemplate.Header>
    <AuthStepTemplate.P keyName='auth.steps.error.p1' />
    <AuthStepTemplate.Footer />
  </AuthStepTemplate>
)
